import React from 'react';
import { Table } from 'semantic-ui-react'

/**
 * Panel view component
 */
export default class PanelView extends React.Component {

	render() {

		// Set relevant list
		const tempPanels = this.props.allPanels.length === 0 ? this.props.actualPanel : this.props.allPanels;

		return  <div>
                    <Table striped selectable>
						<Table.Header>
							<Table.Row>
								<Table.HeaderCell>Célpont neve</Table.HeaderCell>
								<Table.HeaderCell>Célpont azonosító</Table.HeaderCell>
								<Table.HeaderCell>Irsz.</Table.HeaderCell>
								<Table.HeaderCell>Település</Table.HeaderCell>
								<Table.HeaderCell>Cím</Table.HeaderCell>
								<Table.HeaderCell>Szakterület</Table.HeaderCell>
								<Table.HeaderCell>Besorolás</Table.HeaderCell>
								<Table.HeaderCell>Látogatói terület</Table.HeaderCell>
							</Table.Row>
						</Table.Header>
						<Table.Body>
							{
							tempPanels.map( p => <Table.Row>
								<Table.Cell>{p.name}</Table.Cell>
								<Table.Cell>{p.license}</Table.Cell>
								<Table.Cell>{p.postalCode}</Table.Cell>
								<Table.Cell>{p.city}</Table.Cell>
								<Table.Cell>{p.address}</Table.Cell>
								<Table.Cell>{p.myPreferredSpecialtyHu}</Table.Cell>
								<Table.Cell>{p.segmentation}</Table.Cell>
								<Table.Cell>{p.visitorTerritory}</Table.Cell>
							</Table.Row>)
							}
						</Table.Body>
					</Table>
				</div>
	}
}